// extracted by mini-css-extract-plugin
export default {"img-container":"About_img-container__mUEEV","img":"About_img__Z35Xj"};